// extracted by mini-css-extract-plugin
export default {"cell":"VoterCell-module__cell___RvM6U"};